import { render, staticRenderFns } from "./ActivityTypeUpdate.vue?vue&type=template&id=352b336a&scoped=true"
import script from "./ActivityTypeUpdate.vue?vue&type=script&lang=js"
export * from "./ActivityTypeUpdate.vue?vue&type=script&lang=js"
import style0 from "./ActivityTypeUpdate.vue?vue&type=style&index=0&id=352b336a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b336a",
  null
  
)

export default component.exports